import { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "@mui/icons-material";
import CartModal from "./Models/CartModal";
import LoginModal from "./Models/LoginModel";
import CategoriesModel from "./Models/CategoriesModel";
import WishModal from "./Models/WishModal";

import { useAdmin } from "../context/AdminContext";
import SearchProducts from "../pages/SearchProducts";
import SearchProductsMobile from "../pages/SearchProductsMobile";
import logo from "../assets/Tobikor2.png";

const Header = () => {
  const { isAdmin } = useAdmin();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const goToDepartment = (departmentId) => {
    navigate(`/department/${encodeURIComponent(departmentId)}`);
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <header className=" bg-coffeeBrown font-robo text-white fixed top-0 left-0 w-full z-50">
      <div className="flex p-1 lg:p-2 md:p-2 ">
        <Link to="/" className="hidden lg:block md:block ">
          <img src={logo} alt="logo" className="h-10 w-auto " />
        </Link>
        <div className="container mx-auto flex justify-between 2xl:justify-between  items-center ">
          {/* Logo Mobile */}
          <div className="flex mt-2 lg:hidden md:hidden xl:hidden 2xl:hidden ">
            <div className=" relative " ref={dropdownRef}>
              <button
                className=" mr-1 p-1 bg-coffee text-white rounded flex items-center"
                onClick={handleDropdownToggle}
              >
                <Menu fontSize="small" />
              </button>
              {isDropdownOpen && (
                <ul className="absolute mt-2 w-60 bg-white text-small text-black rounded-md max-h-80 overflow-y-auto delay-75 ">
                  <li>
                    <span className=" flex p-2 text-small font-semibold mx-2">
                      All Departments
                    </span>
                  </li>
                  <li>
                    <button
                      className="flex w-full px-4 py-2 hover:text-white hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("computers");
                        handleDropdownToggle();
                      }}
                    >
                      Computers
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("home & Kitchen");
                        handleDropdownToggle();
                      }}
                    >
                      Home & Kitchen
                    </button>
                  </li>

                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("fashion");
                        handleDropdownToggle();
                      }}
                    >
                      Fashion
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("electronics");
                        handleDropdownToggle();
                      }}
                    >
                      Electronics
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("baby");
                        handleDropdownToggle();
                      }}
                    >
                      Baby
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("sports and outdoors");
                        handleDropdownToggle();
                      }}
                    >
                      Sports and Outdoors
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("arts and crafts");
                        handleDropdownToggle();
                      }}
                    >
                      Arts and Crafts
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("foods");
                        handleDropdownToggle();
                      }}
                    >
                      Foods
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("health and household");
                        handleDropdownToggle();
                      }}
                    >
                      Health and Household
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("food");
                        handleDropdownToggle();
                      }}
                    >
                      Food
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("industrial and scientific");
                        handleDropdownToggle();
                      }}
                    >
                      Industrial and Scientific
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("automotives");
                        handleDropdownToggle();
                      }}
                    >
                      Automotives
                    </button>
                  </li>
                  <li>
                    <button
                      className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                      onClick={() => {
                        goToDepartment("tools and home improvement");
                        handleDropdownToggle();
                      }}
                    >
                      Tools and Home Improvement
                    </button>
                  </li>
                </ul>
              )}
            </div>
            {/*  Mobile */}
            <Link to="/" className="ml-1">
              <img src={logo} alt="logo" className="h-7 w-auto " />
            </Link>
          </div>

          {/* Search Bar */}
          <div className=" ml-36 w-1/2 lg:w-1/3  hidden lg:block md:block  ">
            <div className="flex">
              <div className=" relative  ">
                <button
                  className=" mr-1 p-1 bg-coffee text-white rounded flex items-center"
                  onClick={handleDropdownToggle}
                >
                  <Menu />
                </button>
                {isDropdownOpen && (
                  <ul className="absolute mt-2 w-60 bg-white text-small text-black rounded-md max-h-80 overflow-y-auto delay-75 ">
                    <li>
                      <span className=" flex p-2 text-small font-semibold mx-2">
                        All Departments
                      </span>
                    </li>
                    <li>
                      <button
                        className="flex w-full px-4 py-2 hover:text-white hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("computers");
                          handleDropdownToggle();
                        }}
                      >
                        Computers
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("home & Kitchen");
                          handleDropdownToggle();
                        }}
                      >
                        Home & Kitchen
                      </button>
                    </li>

                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("fashion");
                          handleDropdownToggle();
                        }}
                      >
                        Fashion
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("electronics");
                          handleDropdownToggle();
                        }}
                      >
                        Electronics
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("baby");
                          handleDropdownToggle();
                        }}
                      >
                        Baby
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("sports and outdoors");
                          handleDropdownToggle();
                        }}
                      >
                        Sports and Outdoors
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("arts and crafts");
                          handleDropdownToggle();
                        }}
                      >
                        Arts and Crafts
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("foods");
                          handleDropdownToggle();
                        }}
                      >
                        Foods
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("health and household");
                          handleDropdownToggle();
                        }}
                      >
                        Health and Household
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("food");
                          handleDropdownToggle();
                        }}
                      >
                        Food
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("industrial and scientific");
                          handleDropdownToggle();
                        }}
                      >
                        Industrial and Scientific
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("automotives");
                          handleDropdownToggle();
                        }}
                      >
                        Automotives
                      </button>
                    </li>
                    <li>
                      <button
                        className=" flex w-full px-4 py-2 hover:text-white  hover:bg-coffee"
                        onClick={() => {
                          goToDepartment("tools and home improvement");
                          handleDropdownToggle();
                        }}
                      >
                        Tools and Home Improvement
                      </button>
                    </li>
                  </ul>
                )}
              </div>
              {/* DESKTOP */}
              <SearchProducts />
            </div>
          </div>
          {/* User and Cart Icons */}
          <div className="flex lg:items-center ml-24 lg:ml-20 lg:space-x-4 space-x-2 ">
            <h8 className=" text-small text-center flex capitalize  ">
              <LoginModal />
            </h8>
            {isAdmin && (
              <Link
                to="/admin/dashboard"
                className="text-small bg-coffee hover:bg-lightBrown text-white p-1 lg:p-2 rounded hover:text-white"
              >
                Admin
              </Link>
            )}

            <CartModal />
            <WishModal />
          </div>
        </div>
      </div>

      {/* MOBILE */}
      <div className=" lg:hidden md:hidden xl:hidden 2xl:hidden  ">
        <SearchProductsMobile />
      </div>

      {/* WEB */}
      <nav className="bg-coffee text-small min-w-full hidden lg:block md:block">
        <div className="container mx-auto flex space-x-6 text-small p-1">
          <CategoriesModel />
          <Link
            to="/settings/orders"
            className="text-small flex hover:text-white "
          >
            My Orders
          </Link>
          <Link
            to="/settings/messages"
            className=" text-small flex  hover:text-white "
          >
            My Mesages
          </Link>
          <Link
            to="/settings/profile"
            className=" text-small flex  hover:text-white"
          >
            My Profile
          </Link>
          <Link
            to="/settings/track"
            className=" text-small flex  hover:text-white"
          >
            Tracking
          </Link>
          <Link
            to="/settings/about"
            className=" text-small flex  hover:text-white "
          >
            About Us
          </Link>
          <Link
            to="/settings/help"
            className=" text-small flex  hover:text-white"
          >
            Help
          </Link>
        </div>
      </nav>

      {/* MOBILE */}
      <nav className="bg-coffee items-center text-small min-w-96 lg:hidden md:hidden xl:hidden 2xl:hidden">
        <div className="container mx-auto flex space-x-6 text-small p-4 py-2 overflow-x-auto whitespace-nowrap ">
          <Link
            to="/settings/orders"
            className="text-small flex flex-shrink-0 hover:text-white "
          >
            My Orders
          </Link>
          <Link
            to="/settings/messages"
            className=" text-small flex flex-shrink-0 hover:text-white "
          >
            My Mesages
          </Link>
          <Link
            to="/settings/profile"
            className=" text-small flex flex-shrink-0  hover:text-white"
          >
            Tracking
          </Link>
          <Link
            to="/settings/track"
            className=" text-small flex flex-shrink-0  hover:text-white"
          >
            My Profile
          </Link>
          <Link
            to="/settings/about"
            className=" text-small flex flex-shrink-0 hover:text-white "
          >
            About Us
          </Link>
          <Link
            to="/settings/help"
            className=" text-small flex flex-shrink-0 hover:text-white"
          >
            Help
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;
